import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Card } from '@/shared/components/ui/Card'
import { toast } from 'sonner';

import { UserCreateForm } from '@/features/users/components/UserCreateForm';
import { useUserActions } from '@/features/users/hooks/useUsers';
import type { UserCreateRequest } from '@/features/users/types/user';

export const Route = createFileRoute('/_auth/users/add')({
  component: AddUserRoute,
});

function AddUserRoute() {
  const navigate = useNavigate();
  const { createUser, isCreating } = useUserActions();

  const navigateToUsers = useCallback(() => {
    navigate({ to: '/users' });
  }, [navigate]);

  const handleCreateUser = useCallback(
    (user: UserCreateRequest) => {
      createUser(user, {
        onSuccess: () => {
          toast.success('User created successfully');
          navigateToUsers();
        },
        onError: (error) => {
          const errorMessage = error?.message || 'An error occurred while creating the user';
          toast.error(errorMessage);
        }
      });
    },
    [createUser, navigateToUsers],
  );

  return (

      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4">
          <h1 className="text-2xl font-bold mb-6">Add User</h1>
            <Card>
              <UserCreateForm
                onCreate={handleCreateUser}
                onCancel={navigateToUsers}
                isSubmitting={isCreating}
              />
            </Card>
        </div>
     </div>
    
  );
}
